/* 平台创建的排班-时刻表-编辑模式 */
<template>
  <div id="schedulingPlatformTimeForm">

    <!-- 查看线路票价模态框 -->
    <el-dialog class="semoney" :visible.sync="visibleFeeLook" width="40%">
      <div class="updatePrice">
        <span class="detail">{{ detailTitle }}</span>
        <span class="update" v-if="!showEdit" @click="editFee">{{
          lineInfo.railType == 2 && lineInfo.schedulingType == 3
          ? "修改价格"
          : "修改票价"
        }}</span>
      </div>
      <el-form ref="priceForm" :model="priceForm" style="margin: 0 auto">
        <el-table :data="priceForm.stationRailFee" border max-height="250" style="width: 100%">
          <el-table-column prop="startRailName" label="出发地">
          </el-table-column>
          <el-table-column prop="endRailName" label="目的地"> </el-table-column>
          <el-table-column prop="fee" width="180" :label="'票价'">
            <template slot-scope="scope">
              <el-form-item :prop="'stationRailFee.' + scope.$index + '.fee'" :rules="{
                required: true,
                message: '请设置票价',
                trigger: 'blur',
              }">
                <div v-if="showEdit" style="display: flex; padding-right: 2px">
                  <el-input v-model="scope.row.fee" maxlength="3"
                    oninput="value=value.replace(/[^\d]/g, '').replace(/^0/g,'')"
                    style="margin: 0; width: 150px; cursor: pointer">
                    <template slot="prepend">￥</template>
                    <template slot="append"></template>
                  </el-input>
                </div>
              </el-form-item>

              <span v-if="!showEdit">￥{{ scope.row.fee }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="submit">
        <el-button type="primary" @click="editFeeConfirm" v-if="showEdit">保存</el-button>
      </div>
    </el-dialog>

    <!-- 设置票价模态框 -->
    <el-dialog title="线路票价" :visible.sync="visibleFeeSet" width="360px" :close-on-click-modal="false">
      <el-input placeholder="这条路线的售票票价" maxlength="3" oninput="value=value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'')"
        v-model="input2" prop="region">
        <template slot="append">元</template>
      </el-input>
      <div class="motoal">
        <el-button type="primary" size="mini" @click="feeSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 点击列表查看座位 -->
    <el-dialog title="座位详情" :visible.sync="visibleSeats" width="400px" class="LookSeat">
      <div class="seat-top">
        <div class="seat-top-left">
          <span class="seat-top-span1"> </span>可选
        </div>
        <div class="seat-top-right">
          <span class="seat-top-span2"> </span>已购
        </div>
      </div>

      <div class="seat-content">
        <div class="driver">
          <div class="drivers"></div>
          司机
        </div>

        <div class="seat-content-center" :class="seats.length == 4
          ? 'passe1'
          : seats.length == 6
            ? 'passe2'
            : seats.length == 7
              ? 'passe3'
              : seats.length == 8
                ? 'passe4'
                : ''
          " v-for="(item, index) in seats" :key="index">
          <div v-if="item.isSoldTicket == 1" class="content-center">
            <img style="width: 100%; height: 100%" src="../../../assets/img/kexuan1.png" alt="" />
            <span class="seat-details">{{ item.seatNo }}</span>
          </div>
          <div v-if="item.isSoldTicket == 2" class="content-center">
            <img style="width: 100%; height: 100%" src="../../../assets/img/yixuan1.png" alt="" />
            <span class="seat-details1">{{ item.seatNo }}</span>
          </div>
          <p>¥{{ item.fee }}</p>
        </div>
      </div>
      <div class="motoal">
        <el-button type="primary" @click="visibleSeats = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 导入班次时间表 -->
    <el-dialog class="dialog-export-modal" :visible.sync="visibleImport" title="" width="1000px"
      :close-on-click-modal="false">
      <template slot="title">
        <span>导入班次</span>
        <el-button type="text" style="font-size: 14px;" @click="downloadFn">下载模板</el-button>
      </template>
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div>
          <p class="util-remark">1.只能导入当前机构的车辆，车辆必须绑定司机</p>
          <p class="util-remark">2.导入的时间段只能是00:00-24:00之间，导入失败的数据需要您手动补充</p>
        </div>
      </div>
      <!-- <el-table border style="margin-top: 20px" :data="excelList" v-if="excelList && excelList.length > 0">
        <el-table-column prop="a1" label="开始接人/检票时间"></el-table-column>
        <el-table-column prop="a1" label="预计发车时间"></el-table-column>
        <el-table-column prop="a1" label="值班车辆"></el-table-column>
      </el-table> v-else-->
      <el-upload class="upload-demo" accept=".xls,.xlsx" drag :on-change="handleChange" :auto-upload="false"
        :show-file-list="false" action="/api/v1/common/excel/read/import">
        将导入模版拖至该区域或手动选择模版
      </el-upload>
    </el-dialog>

    <!-- 编辑值班车辆班次 -->
    <schedulingVehicle @confirm="vehicleConfirm" :visible.sync="schedulingVehicleShow" :line="lineInfo"
      :scheduling="editShiftForm" :drivers.sync="editShiftDrivers" :multiple="lineInfo.schedulingType == 2"
      :lineOId="lineInfo.organizationId" />

    <div class="schedulingPlatformTimeForm-head">
      <div class="schedulingPlatformTimeForm-head-left">
        <img class="icon-line" src="../../../assets/img/line.png" alt="" />
        <span style="font-weight: 600">{{ lineInfo.startStationName }} - {{ lineInfo.endStationName }}</span>

        <div style="display: flex; height: 28px; margin: 0 30px">
          <span v-if="lineInfo.schedulingType == 1 ||
            lineInfo.schedulingType == 3 ||
            lineInfo.schedulingType == 2
            ">{{ lineInfo.schedulingType | filterConst("SCHELINGTYPE") }}
          </span>
        </div>

        <div v-if="lineInfo.railType !== 2 &&
          (lineInfo.schedulingType == 1 || lineInfo.schedulingType == 2)
          ">
          票价:<span style="color: rgb(255, 153, 0)">{{
            lineInfo.fee == null ? "待设置" : "¥" + lineInfo.fee
          }}</span>
        </div>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="save">保存</el-button>
        <el-button type="primary" style="margin-right: 10px;" @click="$router.back()">取消</el-button>
        <el-button type="primary" style="margin-right: 10px;" v-if="lineInfo.railType == 2"
          @click="showLine">查看票价</el-button>
        <el-button type="primary" v-if="lineInfo.railType == 2" @click="reset">模式重置</el-button>
      </div>
    </div>

    <!-- 班次列表 -->
    <div class="schedulingPlatformTimeForm-body">
      <div class="scheduling-form-date">
        <div class="left">
          <custom-across-roll ref="customAcrossRoll">
            <div class="date" :class="dateActiveIndex == i ? 'active' : ''" v-for="(scheduling, i) in schedulingJson"
              :key="i" @click="dateClick(scheduling, i)" @mouseover="dateHover('over', i, scheduling)"
              @mouseout="dateHover('out', i)">
              <span class="date-text">{{ getWeek(scheduling.schedulingTime) }}
                {{ scheduling.schedulingTime | filterTime("MM-DD") }}</span>
              <span class="date-close" :class="scheduling.removeIconShow ? 'remove' : ''"
                @click.stop="removeSchedulingTime(scheduling, i)">×</span>
            </div>

            <div class="date" v-if="schedulingJson.length < 30" @click="copyScheduling">复制排班</div>
          </custom-across-roll>
        </div>
        <el-button v-if="schedulingJson.length < 30" @click="addScheduling">添加日期</el-button>
      </div>

      <div class="statusSearch">
        <div>
          <strong style="margin-right: 20px">状态：</strong>
          <el-radio-group v-model="status" @change="statusChange" style="margin-right: 50px">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">停止售票</el-radio>
            <el-radio :label="3">售票中</el-radio>
          </el-radio-group>
          <el-checkbox v-model="checked" @change="statusChange">只看有余票</el-checkbox>
        </div>

        <div class="util-remark" v-if="type !== 'view'">
          注意：已创建的班次如需编辑，请返回详情页操作
        </div>
      </div>

      <div class="scheduling-form-table">
        <el-form :model="form" ref="form" label-width="0">
          <el-table :data="shiftFilterTable" border style="width: 100%">
            <el-table-column prop="date" label="状态">
              <template slot-scope="{row}">
                <span v-if="row.status == 1 && row.isEnabled == 1">售票中</span>
                <span v-if="row.status == 2 || row.isEnabled == 2">停止售票</span>
              </template>
            </el-table-column>

            <el-table-column prop="startTime" :label="`开始${[1, 2].includes(lineInfo.lineType) ? '检票' : '接人'}`"
              width="200">
              <template slot-scope="{row}">
                <el-form-item v-if="row.isNew" :prop="'shiftActive.' + row.realIndex + '.startTime'"
                  :rules="[{ validator: validateStart, trigger: 'change' }]">
                  <el-time-picker v-model="row.startTime" format="HH:mm" value-format="HH:mm" :default-value="form.shiftActive[row.realIndex - 1] && form.shiftActive[row.realIndex - 1].startTime
                    ? new Date(2000, 1, 1, form.shiftActive[row.realIndex - 1].startTime.split(':')[0], Number(form.shiftActive[row.realIndex - 1].startTime.split(':')[1]))
                    : new Date()"></el-time-picker>
                </el-form-item>

                <span v-else>{{ row.startTime }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="endTime" label="预计发车" width="200">
              <template slot-scope="{row}">
                <el-form-item v-if="row.isNew" :prop="'shiftActive.' + row.realIndex + '.endTime'"
                  :rules="[{ validator: validateEnd, trigger: 'change' }]">
                  <el-time-picker v-model="row.endTime" format="HH:mm"
                    :default-value="row.startTime ? new Date(2000, 1, 1, row.startTime.split(':')[0], Number(row.startTime.split(':')[1])) : new Date()"
                    value-format="HH:mm"></el-time-picker>
                </el-form-item>
                <span v-else>{{ row.endTime }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="licenseNo" label="值班车辆" v-if="[1, 3].includes(lineInfo.schedulingType)" width="210">
              <template slot-scope="{row}" v-if="row.schedulingVehicleJson">
                <span
                  :class="{ link: lineInfo.schedulingType == 3 }"
                  :style="getPlateStyle(row.schedulingVehicleJson[0].licenseNo)"
                  @click="lookSeat(row)"
                >{{ formatPlateNumber(row.schedulingVehicleJson[0].licenseNo) }}</span>
                <span style="margin-left:5px">{{ row.schedulingVehicleJson[0].vehicleSeat }}座</span>
                <span style="margin-left:5px">{{ row.schedulingVehicleJson[0].driverName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="票数限制" v-if="![1, 3].includes(lineInfo.schedulingType)" width="300">
              <template slot-scope="{row}">
                <el-form-item v-if="row.isNew" :prop="'shiftActive.' + row.realIndex + '.ticketNumType'"
                  :rules="{ required: true, message: '请选择票数限制', trigger: 'blur' }">
                  <el-radio-group v-model="row.ticketNumType">
                    <el-radio :label="1">不限购</el-radio>
                    <el-radio :label="2">限购</el-radio>
                    <el-form-item :prop="'shiftActive.' + row.realIndex + '.ticketNum'"
                      :rules="[{ required: Boolean(row.ticketNumType == 2), message: '请输入限购数量', trigger: 'blur' }]">
                      <el-input class="ticket-num" v-model="row.ticketNum" :disabled="row.ticketNumType == 1"
                        oninput="value=value=value.replace(/[^\d]/g, '').replace(/^0/g, '').replace(/^[1-9][0-9]{3,}/g,'999')">
                        <template slot="append">张</template>
                      </el-input>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
                <span v-else>{{ row.ticketNumType == 1 ? "不限购" : "限购：" + row.ticketNum + "张" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ticketNum" label="可购票" v-if="[1, 3].includes(lineInfo.schedulingType)">
              <template slot-scope="{row}">
                <span>{{ row.ticketNum || "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="soldTickets" label="已购票">
              <template slot-scope="{row}">
                <span>{{ row.ticketNum ? row.soldTickets : "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remainingTickets" label="余票">
              <template slot-scope="{row}">
                {{ row.ticketNum ?
                  (row.remainingTickets ? row.remainingTickets : row.ticketNumType == 1 ? "-" : row.compile ? "-" : 0)
                  : "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" width="180">
              <template slot-scope="{$index,row}">
                <el-button v-if="[1, 3].includes(lineInfo.schedulingType) && row.isNew" type="text"
                  @click="editVehicle(row, $index)">值班车辆</el-button>
                <el-button type="text" @click="addShift($index)" v-if="row.status == 1">向上插班</el-button>
                <el-button v-if="row.isNew" @click="removeFn(row, $index)" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>

        <div class="shiftPush">
          <div class="add" @click="addShift"><i class="el-icon-plus"></i>添加班次</div>
          <div v-if="lineInfo.schedulingType == 1" class="add" @click="visibleImport = true"><i
              class="el-icon-plus"></i>导入班次</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schedulingPlatformTimeForm",
  components: {
    customAcrossRoll: () => import("../../../components/custom-across-roll.vue"),
    schedulingVehicle: () => import("./schedulingVehicle.vue"),
  },
  props: ['lineId', 'type'],
  data() {
    return {
      detailTitle: "线路票价",
      buyBool: false,
      showEdit: false, //显示编辑框
      //票价
      input2: "",
      lastListArr: [],
      //模态框
      visibleFeeSet: false,
      visibleSeats: false,
      visibleFeeLook: false,
      dialogIndex: [],
      dialogDrivers: [],
      dialogScheduling: {},
      schedulingVehicleShow: false,
      today: new Date().setHours(23, 59, 59, 0) / 1000,
      // 日期列表
      dateList: [],
      // 表单对象
      form: {
        // 当前选中的
        shiftActive: [],
      },
      // 筛选后的班次表格
      shiftFilterTable: [],
      // 线路详情信息
      lineInfo: {},
      //线路详情数据
      priceForm: {
        stationRailFee: [],
      },

      // 加载中
      loading: false,

      schedulingJson: [],
      // 选中的日期索引
      dateActiveIndex: 0,
      //点击查看座位数据
      seats: [],

      status: 1,
      checked: false,
      lineOId: "",

      // 编辑司机的班次
      editShiftForm: {},
      // 编辑司机的班次 的值班司机
      editShiftDrivers: [],

      // 所有日期的值班司机
      dutyDrivers: [],

      // 导入班次时间相关参数
      visibleImport: false,
      // excelList: []
    };
  },
  watch: {
    "form.shiftActive"(item) {
      this.statusChange();
      if (this.dutyDrivers[0]) {
        this.$emit('dutyDriversUpdate', this.dutyDrivers[this.dateActiveIndex])
      }

    },
    visibleFeeLook(val) {
      if (!val) {
        this.$refs.priceForm.resetFields();
      }
    },
  },

  async created() {
    await this.getInfo();
  },
  methods: {
    /* 检票时间验证器 */
    validateStart(rule, value, callback) {
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let item = this.form.shiftActive[i].startTime;
      let prevItem = i > 0 ? this.form.shiftActive[i - 1].startTime : null;
      let nextItem = this.form.shiftActive[i + 1] ? this.form.shiftActive[i + 1].startTime : null;
      if (!value) {
        callback(new Error("“接人/检票时间”不能为空"));
      } else if (i > 0 && prevItem && item < prevItem) {
        callback(new Error("请设置大于等于上个班次的“接人/检票时间”"));
      } else if (i < 15 && nextItem && item > nextItem) {
        callback(new Error("请设置小于等于下个班次的“接人/检票时间”"));
      } else {
        callback();
      }
    },
    /* 预计发车验证器 */
    validateEnd(rule, value, callback) {
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let endTime = this.form.shiftActive[i].endTime;
      let startItem = this.form.shiftActive[i].startTime;
      if (!value) {
        callback(new Error("发车时间不能为空"));
      } else if (endTime < startItem) {
        callback(new Error("不能小于“接人/检票时间”"));
      } else {
        callback();
      }
    },

    /* 添加班次 index:插班下标 */
    addShift(index) {
      let row = {
        status: 1,
        startTime: "",
        endTime: "",
        ticketNumType: 1,
        ticketNum: '',
        remainingTickets: 0,
        soldTickets: 0,
        isEnabled: 1,
        show: true,
        addStatus: true,
        isNew: true
      };
      if (this.lineInfo.schedulingType == 1 || this.lineInfo.schedulingType == 3) {
        row.ticketNumType = 2;
      }
      if (typeof index == "number") {
        // 插班
        row.realIndex = index;
        this.form.shiftActive.map((item, i) => {
          if (i > index) {
            ++item.realIndex;
          }
        })
        this.form.shiftActive.splice(index, 0, row);
      } else {
        // 添加
        row.realIndex = this.form.shiftActive.length;
        this.form.shiftActive.push(row);
      }

      this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
    },

    /* 最新的值班车辆列表 */
    async getDutyDriversData() {
      let url = "/api/v1/manage/line/scheduling/line/vehicle/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {

        if (this.schedulingJson.length == 1 && this.schedulingJson[0].isNew) {
          return;
        } else {
          let dutyDrivers = [];
          if (this.schedulingJson.length >= data.data.length) {
            let times1 = this.schedulingJson.map((item) => item.schedulingTime);
            let times2 = data.data.length > 0 ? data.data.map((item) => item.schedulingTime) : [];
            let times = Array.from(new Set([...times1, ...times2]));
            times.map((time) => {
              let target = data.data.find((item) => {
                return time == item.schedulingTime
              });
              if (target) {
                dutyDrivers.push(target)
              } else {
                dutyDrivers.push({
                  isNew: true,
                  schedulingTime: time,
                  vehicleInfo: []
                })
              }
            });
          } else {
            dutyDrivers = data.data;
          }
          this.dutyDrivers = dutyDrivers;
          this.$emit('dutyDriversUpdate', this.dutyDrivers[this.dateActiveIndex]);
        }
      }
    },

    /* 最新的值班车辆列表by某一日 */
    async getDutyDriversDataByTime(schedulingTime) {
      let url = "/api/v1/manage/line/scheduling/line/vehicle/" + this.lineId;
      let data = await this.$axios.get(url, { schedulingTime });
      if (data && data.code == 1 && data.data.length > 0) {
        this.dutyDrivers.map(item => {
          if (item.schedulingTime == schedulingTime) {
            item.vehicleInfo = data.data[0].vehicleInfo;
            this.$emit('dutyDriversUpdate', item)
          }
        })
      }
    },

    /* 更新新加日期的值班车辆列表 */
    isNewVehicleInfoUpdate(data) {
      this.dutyDrivers.map(item => {
        if (item.schedulingTime == data.schedulingTime) {
          item.vehicleInfo = data.vehicleInfo;
          this.$emit('dutyDriversUpdate', item)
        }
      })
    },

    /* 添加日期 */
    async addScheduling() {
      let last = this.schedulingJson[this.schedulingJson.length - 1];
      let row = {
        isNew: true,
        removeIconShow: false,
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        shift: [],
      };
      this.dutyDrivers.push({
        isNew: true,
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        vehicleInfo: []
      })
      this.schedulingJson.push(row);

      this.dateClick(this.schedulingJson[this.schedulingJson.length - 1], this.schedulingJson.length - 1)

      this.$nextTick(() => {
        this.$refs.customAcrossRoll.navNext();
      })
    },

    /* 复制排班 */
    copyScheduling() {
      let last = JSON.parse(JSON.stringify(this.schedulingJson[this.schedulingJson.length - 1]));
      let shift = [];
      last.shift.map((row) => {
        // if (!row.isNew) {
        let schedulingVehicleJson = [];
        let remainingTickets = 0;
        if (row.schedulingVehicleJson) {
          schedulingVehicleJson = row.schedulingVehicleJson.map((scheduling) => {
            remainingTickets += scheduling.vehicleSeat - 1;
            if (scheduling.vehicleSeatAndFeeVos) {
              scheduling.vehicleSeatAndFeeVos = scheduling.vehicleSeatAndFeeVos.map((seat) => {
                seat.id = null;
                return seat;
              });
            }
            return scheduling;
          });
        }
        shift.push({
          id: null,
          status: 1,
          isEnabled: 1,
          schedulingVehicleJson: schedulingVehicleJson.length > 0 ? schedulingVehicleJson : null,
          startTime: row.startTime,
          endTime: row.endTime,
          ticketNumType: row.ticketNumType,
          ticketNum: row.ticketNum,
          soldTickets: 0,
          remainingTickets,
          show: true,
          isNew: true
        });
        // }
      });
      let row = {
        isNew: true,
        removeIconShow: false,
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        shift,
      };
      this.newCopyTime = last.schedulingTime + 24 * 60 * 60;

      this.schedulingJson.push(row);

      if (this.lineInfo.schedulingType == 2) {
        // bug
        let vehicleInfo = JSON.parse(JSON.stringify(this.dutyDrivers[this.dutyDrivers.length - 1].vehicleInfo));

        this.dutyDrivers.push({
          isNew: true,
          schedulingTime: this.newCopyTime,
          vehicleInfo
        })
      }

      this.dateClick(this.schedulingJson[this.schedulingJson.length - 1], this.schedulingJson.length - 1)

      this.$nextTick(() => {
        this.$refs.customAcrossRoll.navNext();
      })
    },

    // 保存
    save() {
      this.$refs.form.validate(async (valid, object) => {
        if (valid) {
          let url = "/api/v1/manage/line/scheduling/add";

          // 排班班次JSON
          let schedulingJson = [];
          // 违规数据记录
          let violationTips = ''
          this.schedulingJson.map(scheduling => {
            let violationBl = false;
            if (scheduling.shift) {
              violationBl = scheduling.shift.find((item, index, arr) => {
                if (item.ticketNumType == 2 && !item.ticketNum && this.lineInfo.schedulingType == 2) {
                  return true
                }
                if (!item.startTime || !item.endTime) {
                  return true
                }
                if (item.startTime > item.endTime) {
                  return true
                }
                if (index > 0 && item.startTime < arr[index - 1].startTime) {
                  return true
                }
                if (index < arr.length - 1 && item.startTime > arr[index + 1].startTime) {
                  return true
                }
              })
            } else if (scheduling.isNew) {
              violationBl = true;
            }
            if (violationBl) {
              violationTips += this.$utils.timeFn(scheduling.schedulingTime, "MM-DD") + ' '
            }

            if (scheduling.isNew) {
              schedulingJson.push(scheduling);
            } else {
              let newRows = [];
              if (scheduling.shift) {
                newRows = scheduling.shift.filter(item => item.isNew || item.isEdit)
              }
              if (newRows.length > 0) {
                schedulingJson.push({
                  schedulingTime: scheduling.schedulingTime,
                  shift: newRows,
                })
              }
            }
          })
          if (violationTips) {
            this.$message.warning(`请检查【${violationTips}】班次信息是否正确`);
            return;
          }

          // 值班车辆JSON
          let vehicleJSON = this.dutyDrivers;
          if (this.lineInfo.schedulingType == 2) {
            let violationTips = '';
            vehicleJSON.map(v => {
              let match = this.schedulingJson.find(s => s.schedulingTime == v.schedulingTime)
              if (v.vehicleInfo.length > 0 && (!match || !match.shift || !match.shift[0])) {
                violationTips += this.$utils.timeFn(v.schedulingTime, "MM-DD") + ' ';
              }
            })
            if (violationTips) {
              this.$message.warning(`请先完善【${violationTips}】班次`);
              return;
            }
          }


          let params = {
            lineId: this.lineId,
            schedulingJson: schedulingJson[0] ? JSON.stringify(schedulingJson) : null,
            vehicleJson: this.lineInfo.schedulingType == 2 && vehicleJSON.length > 0 ? JSON.stringify(vehicleJSON) : null
          };
          let data = await this.$axios.post(url, params);
          if (data && data.code == 1) {
            this.$message.success('已保存');
            this.$router.replace({
              path: "/schedulingSetting",
              query: { lineId: this.lineId }
            });
          }
        } else {
          this.$message.warning(`请检查数据输入是否正确！`);
          return false;
        }
      });
    },

    // 跳转创建班次页面
    createdShift() {
      this.$router.push({ path: 'schedulingPlatformTimeFormEdit', lineId: this.lineId })
    },

    // 模式重置校验
    async resetVerify() {
      let params = {
        lineId: this.lineId,
      };
      let url = "/api/v1/manage/line/reset/verify";
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        return data.data;
      }
    },

    // 模式重置
    async reset() {
      let status = await this.resetVerify();
      if (!status) {
        this.$message.warning("有班次已购票，无法重置");
      } else {
        this.$confirm(
          "重置后会清空所有班次，重新选择排班模式，确定这样做吗？",
          "提示"
        ).then(async () => {
          let url = "/api/v1/manage/line/reset";
          let data = await this.$axios.post(url, { lineId: this.lineId });
          if (data && data.code == 1) {
            this.$router.replace({
              path: '/schedulingTypeForm',
              query: { lineId: this.lineId, lineName: this.lineInfo.startStationName + ' - ' + this.lineInfo.endStationName }
            })
          }
        });
      }
    },

    // 查看路线详情
    async showLine() {
      this.visibleFeeLook = true;
      this.showEdit = false;
      let url = "/api/v1/manage/line/stationRail/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.priceForm.stationRailFee = data.data;
        this.getTickets();
      }
    },

    // 是否购票
    async getTickets() {
      this.visibleFeeLook = true;
      this.showEdit = false;
      let url = "/api/v1/manage/line/queryIsSoldTicketsByLineId/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.buyBool = data.data;
        // this.priceForm.stationRailFee = data.data;
      }
    },

    //点 击查看显示座位
    async lookSeat(row) {
      if (this.lineInfo.schedulingType == 3) {
        if (row.isNew) {
          this.seats = [...row.schedulingVehicleJson[0].vehicleSeatAndFeeVos];
          this.seats.map((row) => {
            row.seatNo = row.seatNo.substring(0, 1);
            row.isSoldTicket = 1;
          });
          this.visibleSeats = true;
        } else {
          this.seats = [];
          let url = "/api/v1/manage/line/vehicle/seatNoAndFee";
          let params = {
            schedulingId: row.id,
            vehicleId: row.schedulingVehicleJson[0].vehicleId,
          };
          let data = await this.$axios.get(url, params);
          if (data && data.code == 1) {
            data.data.map((row) => {
              row.seatNo = row.seatNo.substring(0, 1);
            });
            this.seats = data.data;
            this.visibleSeats = true;
          }
        }
      }
    },

    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },

    //删除班次
    removeFn(row, index) {
      this.$confirm(`确定删除班次吗？`, "提示").then(async () => {
        this.form.shiftActive.splice(index, 1);
        this.form.shiftActive.map((item, i) => {
          if (i > index) {
            --item.realIndex;
          }
        })
        this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
      })
    },

    /* 日期鼠标悬浮 */
    async dateHover(type, i, row) {
      if (type == "over" && row.isNew) {
        this.schedulingJson[i].removeIconShow = true;
      }
      if (type == "out") {
        this.schedulingJson[i].removeIconShow = false;
      }
    },

    /* 点击日期按钮 */
    async dateClick(item, i) {
      this.dateActiveIndex = i;
      this.form.shiftActive = item.shift || [];
    },

    /* 删除某个排班日期 */
    async removeSchedulingTime(scheduling, i) {
      let date = this.$utils.timeFn(this.schedulingJson[i].schedulingTime, "MM-DD");
      this.$confirm(`确认删除该日期(${date})下全部班次吗？`, "删除提示").then(async () => {
        if (this.schedulingJson.length > 0 && i == this.schedulingJson.length - 1) {
          this.schedulingJson.pop();
          this.dutyDrivers.pop();
          this.dateClick(scheduling, i - 1)
        } else {
          scheduling.shift = []
          this.dateClick(scheduling, i)
        }
      });
    },


    async queryIsSoldTickets(schedulingId) {
      if (!schedulingId) {
        return false;
      } else {
        let url = "/api/v1/manage/line/queryIsSoldTickets/" + schedulingId;
        let data = await this.$axios.get(url);
        if (data && data.code == 1) {
          return data.data;
        } else {
          return false;
        }
      }
    },

    /* 编辑值班车辆 */
    async editVehicle(row, index) {
      let status = await this.queryIsSoldTickets(row.id);
      if (status) {
        this.$message.warning("该班次已有乘客购票，无法编辑车辆");
        this.refresh(this.lineInfo.schedulingType);
      } else {
        this.schedulingVehicleShow = true;
        this.editShiftForm = row;
        this.editShiftDrivers = row.schedulingVehicleJson || [];
      }
    },

    /* 确定值班车辆 */
    async vehicleConfirm(result) {
      // 更新行票数
      if ([1, 3].includes(this.lineInfo.schedulingType)) {
        let ticketNum = result.reduce((a, b) => a + (b.vehicleSeat - 1), 0);
        this.editShiftForm.ticketNum = ticketNum;
        this.editShiftForm.soldTickets = 0;
        this.editShiftForm.remainingTickets = ticketNum;
        if (result[0].vehicleSeatAndFeeVos) {
          result[0].vehicleSeatAndFeeVos = result[0].vehicleSeatAndFeeVos.map(item => {
            delete item.id;
            return item;
          });
        }
      }

      if (this.lineInfo.schedulingType != 3) {
        // 不是选座模式就把座位价格字段删除
        delete result[0].vehicleSeatAndFeeVos
      }

      this.editShiftForm.isEdit = true;
      this.editShiftForm.schedulingVehicleJson = [{ ...result[0] }];
    },

    refresh(schedulingType) {
      this.dateActiveIndex = 0;
      this.schedulingJson = [];
      this.form = {
        shiftActive: []
      };
      this.lineInfo.fee = null;
      this.lineInfo = {
        schedulingType,
      };

      this.getInfo();
    },

    /* 状态筛选 */
    statusChange() {
      if (this.form.shiftActive && this.form.shiftActive[0]) {
        this.form.shiftActive.map((item) => {
          item.show = false;
          if (this.status == 1) {
            item.show = true;
          } else if (this.status == 2) {
            item.show = item.status == 2 || item.isEnabled == 2;
          } else if (this.status == 3) {
            item.show = item.status == 1 && item.isEnabled == 1;
          }
          if (this.checked && item.show) {
            item.show = item.remainingTickets > 0 || item.ticketNumType == 1;
          }
        });

        this.shiftFilterTable = this.form.shiftActive.filter((item, index) => { item.realIndex = index; return item.show })
      } else {
        this.shiftFilterTable = [];
      }
    },

    /* 获取平台排班信息 */
    async getInfo() {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let res = await this.$axios.get(url, { channel: 1 });
      if (res?.code == 1) {
        res = res.data;
        this.lineOId = res?.line?.organizationId;
        this.schedulingJson = [];
        if (res?.line?.schedulingType) {
          let currentList = [];
          if (res.scheduling?.length > 0) {
            currentList = res.scheduling.map((item) => {
              let soldTicketsSum = 0;
              if (item.shift && item.shift.length > 0) {
                soldTicketsSum = item.shift.reduce(function (prev, cur) {
                  return cur.soldTickets + prev;
                }, 0);
              }
              item.soldTicketsSum = soldTicketsSum;
              return item;
            });

            let times1 = res.lineVehicleList ? res.lineVehicleList.map((item) => item.schedulingTime) : [];
            let times2 = res.scheduling ? res.scheduling.map((item) => item.schedulingTime) : [];
            let times = Array.from(new Set([...times1, ...times2]));
            currentList.forEach((item) => {
              let target = times.find((time) => time == item.schedulingTime);
              // 判断是不是已有的数据
              if (target) {
                // 班次信息数据初始化
                this.schedulingJson.push(item);
              }
            });

            if (this.$route.query.dateActiveIndex) {
              this.dateActiveIndex = this.$route.query.dateActiveIndex;
            }
            this.form.shiftActive = currentList && currentList.length > 0 && currentList[this.dateActiveIndex].shift ? currentList[this.dateActiveIndex].shift : [];

          } else {
            // 班次为空情况下
            let tomorrow = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点

            this.schedulingJson.push({
              isNew: true,
              schedulingTime: tomorrow,
              shift: [],
            });

            this.dutyDrivers.push({
              isNew: true,
              schedulingTime: tomorrow,
              vehicleInfo: []
            })

            this.form.shiftActive = [];
          }
        }
        this.lineInfo = res.line || {};
        this.$emit("infoUpdate", this.lineInfo);



        if (this.lineInfo.schedulingType == 2) {
          this.getDutyDriversData()
        }
      }
    },

    // 设置班车票价
    async feeSave() {
      if (this.input2 == 0) {
        this.$message({
          message: "票价不能为0元!",
          type: "error",
        });
        return false;
      }

      this.visibleFeeSet = false;
      let params = {
        lineId: this.lineId,
        fee: this.input2,
      };
      let url = "/api/v1/manage/line/saveLineFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.lineInfo.fee = this.input2;
        this.input2 = "";
      }
    },

    /* 修改票价 */
    editFee() {
      if (this.buyBool) {
        this.$message({
          message: "已有乘客购票，无法修改票价",
          type: "warning",
        });
      } else {
        this.detailTitle = "修改票价";
        this.showEdit = true;
      }
    },

    //修改线路价格
    async editFeeConfirm() {
      this.$refs.priceForm.validate((valid) => {
        if (valid) {
          let params = {};
          params.stationRailFee = JSON.stringify(this.priceForm.stationRailFee);
          this.updateRailFee(params);
        }
      });
    },

    //修改线路价格
    async updateRailFee(params) {
      let url = "/api/v1/manage/line/stationRail/updateRailFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("编辑成功！");
      }
      this.visibleFeeLook = false;
      this.detailTitle = "线路票价";
    },

    /* 下载导入班次模板 */
    downloadFn() {
      window.open('/scheduling.xlsx');
    },
    /* 待上传文件变化 */
    handleChange(val) {
      if (!/\.(xls|xlsx)$/.test(val.name)) {
        this.$message.warning("只能导入.xls，.xlsx类型的文件", "warning");
        return false;
      }
      this.uploadFn(val);
    },
    /* 获取excel排班文件列表 */
    async uploadFn(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("excelType", 'SchedulingStandard');
      formData.append("organizationId", this.lineInfo.organizationId);
      let data = await this.$axios.post(
        "/api/v1/common/excel/read/import",
        formData
      );
      if (data && data.code === 1 && data.data) {
        // this.excelList = data.data;
        this.importShift(data.data)

      }
    },
    /* 导入班次 index:插班下标 */
    importShift(excelList) {
      excelList.map(item => {
        let row = {
          status: 1,
          startTime: item.startTime,
          endTime: item.endTime,
          ticketNumType: 1,
          ticketNum: item.ticketNum,
          remainingTickets: item.remainingTickets,
          soldTickets: 0,
          isEnabled: 1,
          show: true,
          addStatus: true,
          isNew: true,
          realIndex: this.form.shiftActive.length,
        };
        if (item.schedulingVehicleJson[0].vehicleId) {
          row.schedulingVehicleJson = item.schedulingVehicleJson
        }
        if (this.lineInfo.schedulingType == 1 || this.lineInfo.schedulingType == 3) {
          row.ticketNumType = 2;
        }
        this.form.shiftActive.push(row);
      })

      this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
      this.$message.success("导入成功！");
      this.visibleImport = false;
    },
  },
};
</script>

<style lang="less" scoped>
#schedulingPlatformTimeForm {
  .schedulingPlatformTimeForm-head {
    padding-bottom: 10px;
    border-bottom: 1px rgb(221, 221, 221) solid;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      color: #333333;

      .icon-line {
        width: 20px;
        margin-right: 8px;
        height: auto;
      }

      .icon-type {
        font-size: 16px;
        margin-left: 22px;
        font-weight: 500;
        line-height: 30px;
        border-radius: 4px;
        color: #409efc;
        padding: 2px 8px;
        background: rgba(64, 158, 252, 0.1);
      }

      .line-money {
        display: flex;
        align-items: center;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        height: 36px;
        padding: 0 12px;
        margin-left: 22px;

        img {
          width: 20px;
          height: auto;
          margin-right: 4px;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }
      }
    }
  }

  .schedulingPlatformTimeForm-body {
    display: flex;
    flex-flow: column;

    .statusSearch {
      margin: 20px 0 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div:nth-child(1) {
        display: flex;
        align-items: center;
      }
    }

    .el-input {
      min-width: 100px;
      width: 100%;
    }

    .ticket-num {
      width: 110px;

      /deep/ input {
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  .scheduling-form-date {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;

    .left {
      flex-grow: 1;
      margin-right: 12px;
      overflow: hidden;
    }
  }

  .scheduling-form-table {
    width: 100%;

    /deep/ .el-table__cell {
      // padding: 0;
    }

    /deep/ .is-error {
      padding-bottom: 25px;
    }

    .el-input__inner {
      width: 100%;
    }

    .el-radio-group {
      display: flex;
      align-items: center;

      .el-input-group__append {
        padding: 0 6px;
      }
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ebeef5 !important;
      outline: none;

      th,
      td {
        height: 38px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        width: 130px;
        border-color: #ebeef5 !important;
        box-sizing: border-box;
        padding: 0 12px;
      }

      th {
        background-color: #fafafa;
        text-align: left;
      }

      .gray td {
        color: #999 !important;
      }
    }

    .table_scheduling {
      .el-button {
        margin-left: 0;
        margin-right: 10px;
      }

      .th1,
      .th5,
      .th7,
      .th8 {
        width: 80px;
      }

      .th6 {
        width: 120px;
      }

      .th4 {
        width: 160px;
        padding: 12px;
        line-height: 20px;
      }
    }

    .el-form-item__error {
      z-index: 10;
      white-space: nowrap;
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-radio {
    position: relative;
    top: 1.5px;
  }

  .motoal {
    text-align: center;
    margin-top: 20px;
  }

  // 禁用input的number箭头
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /deep/ .el-dialog {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding-top: 20px;
    }

    .el-input-group__prepend {
      padding: 0 10px;
    }

    .el-input-group .el-input__inner {
      border-radius: 0px 4px 4px 0 !important;
      border-right: 1px solid #dcdfe6 !important;
    }
  }
}

.LookSeat {
  .seats-price {
    padding: 0 0 0 160px;
    box-sizing: border-box;
  }

  .seat-top {
    display: flex;
    justify-content: center;

    >div {
      display: flex;
      align-items: center;
    }

    .seat-top-left {
      margin-right: 40px;
    }

    .seat-top-right {
      margin-left: 20px;
    }

    .seat-top-span1 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/kexuan.png") no-repeat;
      background-size: 100% 100%;
    }

    .seat-top-span2 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/yixuan.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .seat-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .content-center {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      position: relative;

      .seat-details {
        color: #409efc;
        position: absolute;
        top: -4px;
        left: 15px;
      }

      .seat-details1 {
        color: #fff;
        position: absolute;
        top: -4px;
        left: 15px;
      }
    }

    .driver {
      text-align: center;
      font-weight: bold;
      margin-left: 100px;
      margin-top: 10px;
    }

    .drivers {
      margin-bottom: 8px;
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: url("../../../assets/img/siji.png");
      font-weight: bold;
    }
  }

  .passe1 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 60px;
      margin-right: 60px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 50px;
    }

    &:nth-child(5) {
      margin-left: 40px;
    }
  }

  .passe2 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
      margin-right: 20px;
    }

    &:nth-child(5) {
      margin-left: 70px;
    }

    &:nth-child(6) {
      margin-left: 45px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }
  }

  .passe3 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 70px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 45px;
    }

    &:nth-child(5) {
      margin-left: 45px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }

    &:nth-child(8) {
      margin-left: 45px;
    }
  }

  .passe4 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 0px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
    }

    &:nth-child(5) {
      margin-left: 100px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 78px;
    }

    &:nth-child(8) {
      margin-left: 40px;
    }

    &:nth-child(9) {
      margin-left: 40px;
    }
  }
}

.updatePrice {
  margin-top: -20px;
  margin-bottom: 20px;

  .detail {
    font-size: 17px;
    font-weight: bolder;
    padding-right: 10px;
  }

  .update {
    cursor: pointer;
    color: #0288ff;
  }
}

.submit {
  margin-top: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 100px;
    padding: 7px 15px;
  }
}

.shiftPush {
  display: flex;
  justify-content: space-between;
}

.add {
  flex-grow: 1;
  margin-top: 12px;
  border: 1px #ebebeb dashed;
  line-height: 28px;
  text-align: center;
  cursor: pointer;

  &:hover {
    border-color: @color-primary;
    color: @color-primary;
  }

  &:nth-child(1) {
    margin-right: 20px
  }
}

.upload-demo {
  width: 100%;
  margin-top: 20px;

  /deep/ .el-upload,
  /deep/ .el-upload-dragger {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
